import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <section className="section page-section not-found">
      <h1>404</h1>
      <p>No encontramos la página que buscas.</p>
      <Link to="/" className="btn btn-primary">Volver al inicio</Link>
    </section>
  );
}
